module.exports = __webpack_public_path__ + "static/10-arm-ca07267112ca314202c57fa6c7f9eb37.png";